<template>
  <div>
    <h4>Effect</h4>

    <div class="row">
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label for="animation_selector" class="col-sm-4 col-form-label">
              Effect Selector
            </label>
            <div class="col-sm-8">
              <select id="animation_selector"
                v-model="activeEffect.objectDbHash"
                class="custom-select"
                @change="changeSelectedEffect(event)"
              >
                <option v-for="(effectSelector, key) in effects"
                        :key="key"
                        class="custom-select"
                        :value="key">
                  {{ effectSelector.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="animation_selector" class="col-sm-4 col-form-label">
              Effect Type
            </label>
            <div class="col-sm-8">
              <select id="animation_selector"
                v-model="activeEffect.effectType"
                class="custom-select"
              >
                <option value="2D"> 2D </option>
                <option value="3D"> 3D </option>
              </select>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="start_time" class="col-sm-4 col-form-label">
              Start Time
            </label>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="start_time"
                v-model="activeEffect.startTime"
                @change="changeDuration()"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="end_time" class="col-sm-4 col-form-label">
              End Time
            </label>
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="end_time"
                v-model="activeEffect.endTime"
                @change="changeDuration()"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label for="presentation_duration" class="col-sm-4 col-form-label">
              Presence Duration
            </label>
            <div class="col-sm-8">
              <input
                type="number"
                readonly
                class="form-control"
                id="presentation_duration"
               :value="(parseFloat(activeEffect.endTime) - parseFloat(activeEffect.startTime)).toFixed(2)"
               :class="{'border-danger': (parseFloat(activeEffect.endTime) - parseFloat(activeEffect.startTime)).toFixed(2) <= 0}"
              />
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Loop
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <div class="input-switch label-right p-0">
                  <input type="checkbox" v-model="activeEffect.loop" id="loop">
                  <label for="loop" class="label-left">
                    <span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="fields-wrapper">
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Position of the Origin 
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_x"
                  v-model="activeEffect.position[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_y"
                  v-model="activeEffect.position[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_z"
                  v-model="activeEffect.position[2]"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Rotation of the Origin
            </label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_x"
                  v-model="activeEffect.rotation[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_y"
                  v-model="activeEffect.rotation[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_z"
                  v-model="activeEffect.rotation[2]"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center">
            <label class="col-sm-4 col-form-label">
              Scale (in meters)
            </label>
            <div class="col-sm-8">
              <div class="row align-items-center">
                <div class="col-8">
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.1"
                    v-model="activeEffect.scale"
                  />
                </div>
                <span class="col-4">{{ activeEffect.scale }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {db} from '../../../../../firebaseDB'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
  components: {},
  props: ['selectedCharacterName'],
  data () {
    return {
      activeEffect: {},
      inputData: {
        elementType: 'Character',
        name: '',
        startTime: 0,
        endTime: 10,
        presenceDuration: '',
        bakedLighting: '',
        polygonCount: '',
        positionOfOrigin: {
          x: 0.2,
          y: 0.1,
          z: 0.1
        },
        rotationOfOrigin: {
          x: 0,
          y: 0,
          z: 0
        },
        scale: 0,
        dimensions: {
          x: 0,
          y: 0,
          z: 0
        },
        rigType: '',
        material: '',
        interactiveSurface: '',
        origin: {
          position: {
            x: 0,
            y: 0,
            z: 0
          },
          rotation: {
            x: 0,
            y: 0,
            z: 0
          }
        }
      },
      saveData: {
        character: {
          name: '',
          startTime: '',
          endTime: '',
          presenceDuration: '',
          bakedLighting: '',
          polygonCount: '',
          scale: 0,
          dimensions: [],
          rigType: '',
          material: '',
          interactiveSurface: '',
          origin: {
            position: [],
            rotation: []
          }
        }
      }
    }
  },
  created () {
    // this.inputData.name = this.selectedCharacterName
  },
  methods: {
    changeSelectedEffect (event = null) {
      if (event) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === this.activeEffect.objectId
            ? {
              ...char,
              objectDbHash: event.target.value,
              name: this.effects[event.target.value].name,
              effectType: this.effects[event.target.value].effectType || '2D',
              prefabName: this.effects[event.target.value].prefabName || this.effects[event.target.value].name,
              iOSAssetBundle:  this.effects[event.target.value].asset_bundle ? this.effects[event.target.value].asset_bundle.iOS.fileURL : "",
              AndroidAssetBundle: this.effects[event.target.value].asset_bundle ? this.effects[event.target.value].asset_bundle.android.fileURL : "",
              webglAssetBundle: this.effects[event.target.value].asset_bundle ?this.effects[event.target.value].asset_bundle.WebGL.fileURL : "",
            }
            : { ...char }
        )
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    },
    changeDuration() {
      this.activeEffect.duration = (parseFloat(this.activeCharacter.endTime) - parseFloat(this.activeCharacter.startTime)).toFixed(2);
      this.activeEffect.presenceDuration = (parseFloat(this.activeCharacter.endTime) - parseFloat(this.activeCharacter.startTime)).toFixed(2);
    },
    saveToDB () {
      this.saveData.elementType = this.inputData.elementType
      if (this.$store.state.nodeElementIndex === 2) {
        this.saveData.elementType = 'Object3D'
        this.saveData.successCallback = this.showToast
      }
      this.saveData.character.name = this.inputData.name
      this.saveData.character.startTime = this.inputData.startTime
      this.saveData.character.endTime = this.inputData.endTime
      this.saveData.character.presenceDuration = this.inputData.presenceDuration
      this.saveData.character.bakedLighting = this.inputData.bakedLighting
      this.saveData.character.polygonCount = this.inputData.polygonCount
      this.saveData.character.origin.position.push(this.inputData.positionOfOrigin.x)
      this.saveData.character.origin.position.push(this.inputData.positionOfOrigin.y)
      this.saveData.character.origin.position.push(this.inputData.positionOfOrigin.z)
      this.saveData.character.origin.rotation.push(this.inputData.rotationOfOrigin.x)
      this.saveData.character.origin.rotation.push(this.inputData.rotationOfOrigin.y)
      this.saveData.character.origin.rotation.push(this.inputData.rotationOfOrigin.z)
      this.saveData.character.scale = this.inputData.scale
      this.saveData.character.dimensions.push(this.inputData.dimensions.x)
      this.saveData.character.dimensions.push(this.inputData.dimensions.y)
      this.saveData.character.dimensions.push(this.inputData.dimensions.z)
      this.saveData.character.rigType = this.inputData.rigType
      this.saveData.character.material = this.inputData.material
      this.saveData.character.interactiveSurface = this.inputData.interactiveSurface
      this.saveData.character.type = this.$parent.showComponentType
      this.saveData.character.objectId = 'kg835u7t'
      this.saveData.character.layer = 1
      this.saveData.successCallback = this.showSuccessToast
      this.saveData.errorCallback = this.showErrorToast
      let _this = this
      db.ref().child('assets/asset_data/character_model').orderByChild('name')
        .equalTo(this.$parent.selectedCharecterName).on('value', function (snapshot) {
        if (snapshot.val()) {
          let data = snapshot.val()
          for (const snapshotkey in data) {
            _this.saveData.character.objectDbHash = snapshotkey
            _this.saveData.character.AndroidAssetBundle = data[snapshotkey].asset_bundle.Android.fileURL
            _this.saveData.character.iOSAssetBundle = data[snapshotkey].asset_bundle.iOS.fileURL
            _this.saveData.character.webglAssetBundle = data[snapshotkey].asset_bundle.WebGL.fileURL
            _this.$store.dispatch('saveInspector', _this.saveData)
          }
        } else {
          _this.saveData.character.objectDbHash = ''
          _this.saveData.character.AndroidAssetBundle = ''
          _this.saveData.character.iOSAssetBundle = ''
          _this.$store.dispatch('saveInspector', _this.saveData)
        }
      })
    },
    showSuccessToast () {
      this.$toast('Main inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Main inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    getActiveEffect() {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeEffect = char
          found = true
        }
      }
      if (!found) {
        this.activeEffect = this.characters[0]
      }
      this.inputData = this.activeEffect
    },
  },
  mounted () {
    this.getActiveEffect()
  },
  computed: {
    ...mapState([
      'effects',
      'characters'
    ]),
    startTime: {
      get: function () {
        return this.$store.state.inspector.main.startTime
      },
      set: function (newVal) {
        this.inputData.startTime = newVal
        this.$store.dispatch('saveInspector', this.inputData)
      }
    },
    endTime: {
      get: function () {
        return this.$store.state.inspector.main.endTime
      },
      set: function (newVal) {
        this.inputData.endTime = newVal
        this.$store.dispatch('saveInspector', this.inputData)
      }
    },
    name: {
      get: function () {
        return this.$store.state.inspector.main.name
      },
      set: function (newVal) {
        this.inputData.name = newVal
        this.$store.dispatch('saveInspector', this.inputData)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/effects/maininspector.vue